/** Escape sequences that could close a script tag in HTML (defense-in-depth for JSON-LD). */
export function sanitizeJsonLdString(jsonString: string): string {
  return jsonString.replace(/<\/script/gi, '<\\/script');
}
